export class VendorSignature {
  documentId: number;
  fileExtension: string;
  signatureContent: string;
}
